'use client'
import { Props } from '../product-information'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'

export const Article = ({ product }: { product: Props['product'] }) => {
  const { translate } = useTranslations()
  const copySkuId = async (productId: string) => {
    await navigator.clipboard.writeText(productId)
  }
  return (
    <div className="c-product-article">
      {product.id === product.manufacturerProductIdentifier ? (
        <div>
          <span className="u-color-mute">
            {translate('ProductID')} ({product.manufacturerName} &amp; Dustin):{' '}
          </span>
          <span style={{ whiteSpace: 'nowrap' }}>{product.id}</span>
        </div>
      ) : (
        <>
          <div className="c-product-article__manufacturer-nr">
            <span className="u-color-gray-07">
              {product.manufacturerName} {translate('ProductID').toLowerCase()}{' '}
            </span>
            <span className="u-color-mute" style={{ whiteSpace: 'nowrap' }}>
              {product.manufacturerProductIdentifier}
            </span>
          </div>
          <div className="c-product-article__dustin-nr">
            <span className="u-color-gray-07">Dustin {translate('ProductID').toLowerCase()} </span>
            <span
              className="u-color-mute"
              style={{ whiteSpace: 'nowrap' }}
              onClick={() => copySkuId(product.id)}>
              {product.id}
            </span>
          </div>
        </>
      )}
    </div>
  )
}
